export default __webpack_public_path__ + "static/media/history-icon-2.6c901d54.svg";